// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ShoppingOutlinedSvg from "@ant-design/icons-svg/es/asn/ShoppingOutlined";
import AntdIcon from '../components/AntdIcon';

var ShoppingOutlined = function ShoppingOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ShoppingOutlinedSvg
  }));
};

ShoppingOutlined.displayName = 'ShoppingOutlined';
export default React.forwardRef(ShoppingOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ShoppingOutlined.js
// module id = 1795
// module chunks = 0